import moment from 'moment';
import { isEqual } from "lodash";
import { Itinerary } from "../objects/itinerary";
import { ItineraryInput } from "../objects/itineraryState";

export function areStepsEqual(
    a: ItineraryInput | Itinerary,
    b: ItineraryInput | Itinerary,
    ignoreTransport = false
): boolean {
    const aData = {
        step_order: a.step_order,
        step_type: a.step_type,
        city_name: a.city_name,
        country_name: a.country_name,
        circuit: a.circuit,
        circuit_trip_version: a.circuit_trip_version,
        circuit_start_date: a.circuit_start_date ?
            moment.utc(a.circuit_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') :
            null,
        variant: a.variant,
        iti_type: a.iti_type ?? null,
        stack_info: a.stack_info ?? null,
        r2r_json: ignoreTransport ? null : a.r2r_json ? a.r2r_json : {},
        destination: a.destination && 'id' in a.destination ? a.destination?.id : a.destination?.destination_id,
        // `HH` (24h), never `h`: the 12h token carries no meridiem, so 21:00 and 09:00 both render
        // "9:00" and the step reads as unchanged — the departure hour edit was then dropped by every
        // consumer of this helper (save diff, array_patch body, unsaved-data route block).
        start_date: moment.utc(a.start_date).format('DD/MM/YYYY HH:mm'),
        end_date: moment.utc(a.end_date).format('DD/MM/YYYY HH:mm'),
        free_step: a.free_step,
        auto_offset_step: a.auto_offset_step
    };
    const bData = {
        step_order: b.step_order,
        step_type: b.step_type,
        city_name: b.city_name,
        country_name: b.country_name,
        circuit: b.circuit,
        circuit_trip_version: b.circuit_trip_version,
        circuit_start_date: b.circuit_start_date ?
            moment.utc(b.circuit_start_date, 'YYYY-MM-DD').format('YYYY-MM-DD') :
            null,
        variant: b.variant,
        iti_type: b.iti_type ?? null,
        stack_info: b.stack_info ?? null,
        r2r_json: ignoreTransport ? null : b.r2r_json ? b.r2r_json : {},
        destination: b.destination && 'id' in b.destination ? b.destination?.id : b.destination?.destination_id,
        start_date: moment.utc(b.start_date).format('DD/MM/YYYY HH:mm'),
        end_date: moment.utc(b.end_date).format('DD/MM/YYYY HH:mm'),
        free_step: b.free_step,
        auto_offset_step: b.auto_offset_step
    };
    return isEqual(aData, bData);
}
